export const updateCurrentEdge = ({ id, updateSourceId, edges }) => {
  const updatedEdges = edges.map((edge) => {
    if (edge.source === id) {
      return { ...edge, source: updateSourceId };
    }
    return edge;
  });
  return updatedEdges
};
